// removed by extract-text-webpack-plugin
module.exports = {"tipbox":"tipbox__lCOPn","image":"image__39Aiw","tip":"tip__pUvPK"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/tipbox.scss
// module id = 1236
// module chunks = 68